import React, { useState } from "react";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { Layout } from "@kursk/components/Layout/Layout";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Socials } from "../Home/Socials/Socials";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import styles from './Places.module.scss';
import { placesSlice } from "@common/redux/slices/entities.slice";
import { PlacesGrid } from "./PlacesGrid/PlacesGrid";
import { PlacesMap } from "./PlacesMap/PlacesMap";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { Filters } from "@kursk/components/ui/Filters/Filters";
import { SwitchMapButton } from "@kursk/components/ui/SwitchMapButton/SwitchMapButton";
import { regionContent } from "@kursk/content/regionContent";
import { HeroBlock } from "@kursk/components/ui/HeroBlock/HeroBlock";
import { picksSlice } from "@common/redux/slices/picks";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";

export const Places = () => {
  const { total, meta, filters } = useSelectSlice(placesSlice);
  const { listEvents, listTouristRoutes, listOverviews } = useSelectSlice(recommendationSlice);
  const selectedTags = filters.allTags;
  const selectedTag = (meta.tags && selectedTags.length === 1) && meta.tags.find((tag) => tag._id === selectedTags[0]);
  const { bannersInCatalogs } = useSelectSlice(picksSlice);
  const [currentView, setCurrentView] = useState<'list' | 'map'>('list');

  const onSwitchToMap = () => {
    setCurrentView('map');
  };

  const onSwitchToList = () => {
    setCurrentView('list');
  };

  return (
    <Layout showSubscribePopup={false} page="places">
      <SeoMetaTitles
        page="places"
        selectedTag={selectedTag}
        titleOg={getEntitiesListTitle(meta.tags, selectedTags, 'места')}
        meta={meta}
      />
      <HeroBlock banners={bannersInCatalogs} page="places"/>
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            page="places"
            tags={meta.tags}
            selectedTags={selectedTags}
            title={'места'}
            dashTitle={'Найдено мест'}
            total={total}
            withSwitchMap={regionContent.componentsConfig?.placesWithMap}
            switchMapComponent={(
              <SwitchMapButton
                currentView={currentView}
                onSwitchToMapClick={onSwitchToMap}
                onSwitchToListClick={onSwitchToList}
              />
            )}
          />
        </div>
        <div className={styles.filters}>
          <Filters
            entityType={'places'}
            meta={meta}
            filters={filters}
            withAudio
            withLocales
            withPrices
            withPricesOptions={{
              withFreeCheckbox: true,
              withTicketsCheckbox: true,
              dropDownTitle: 'Цена (₽)'
            }}/>
        </div>
        <div className={styles.items}>
          {currentView === 'list' && (
            <PlacesGrid />
          )}
          {currentView === 'map' && (
            <PlacesMap filters={filters} />
          )}
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="events"
            data={listEvents}
            title={'Рекомендуем посетить'}
            goTo={'/events'}
            goToTitle={'все события'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="touristroutes"
            data={listTouristRoutes}
            title={`Рекомендуем спланировать ${regionContent.entitiesNames.touristroutes.genitive}`}
            goTo={'/touristroutes'}
            goToTitle={`все ${regionContent.entitiesNames.touristroutes.plural}`}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="overviews"
            data={listOverviews}
            title={'Рекомендуем почитать'}
            goTo={'/overviews'}
            goToTitle={'все обзоры'}/>
        </div>
        <div className={styles.recommendationSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
